module.exports = __webpack_public_path__ + "static/media/fungeye.ebbc4a4c.mp4";